@if(!disabled() || !selectedTimeSlot()) {
  <div class="time-select-wrapper">
    <cwo-dropdown-selection
      [label]="'Time'"
      [options]="formattedTimeSlots()"
      [selected]="selectedTimeSlot()"
      (selectionChange)="onTimeSelectionChange($event)"
      [required]="stared()"
      [placeholderIcon]="iconNameType.clock"
    ></cwo-dropdown-selection>
  </div>
}